/*
 * The one thing an administrator does to somebody else's message: remove it (matrix
 * `admin.chat.message.delete`, `DELETE /api/chat/messages/{id}`, audited).
 *
 * It is a plain module beside the row that needs it rather than a `ChatDeps` field, because chat's
 * HTTP calls all live that way (`modules/chat/api.ts`): a dependency is declared only for something
 * the boot alone can bind — a socket type, say, the way `reactions/deps.ts` binds a reaction. A
 * route needs nothing bound.
 *
 * The call goes through `withStepUp`, because the cell is `AUH`: the server answers
 * `403 stepUpRequired` for a session whose stamps are stale, the one mounted `StepUpHost` asks for
 * the proof and the original request is retried once. Without the wrapper an administrator would
 * see a refusal instead of a password prompt.
 */

import { withStepUp } from "../../../core/auth/index.ts"
import { api } from "../../../core/net/api.ts"
import type { MessageId } from "../../../core/store/model.ts"

/**
 * Removes anybody's message. The tombstone that replaces it says an administrator did it — the
 * server sets `byAdmin`, and the row every reader sees arrives over the socket like any other
 * change, so nothing is written into the model here.
 */
export function deleteMessageAsAdmin(id: MessageId): Promise<void> {
	return withStepUp(() => api.del<void>(`/api/chat/messages/${String(id)}`))
}
